import { getAdressenGatewayRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "api/";

const AdressenGatewayApi = {
	listGemeenten() {
		const adressenGatewayRoot = getAdressenGatewayRoot();
		const serviceUrl = `${adressenGatewayRoot}${routePrefix}gemeenten`;

		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	listStratenByGemeenteIdAndPostcode(gemeenteId, postcode) {
		const adressenGatewayRoot = getAdressenGatewayRoot();
		const serviceUrl = `${adressenGatewayRoot}${routePrefix}straten/${gemeenteId}/${postcode}`;

		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	listHuisnummers(gemeenteId, postcode, straatnaam) {
		const adressenGatewayRoot = getAdressenGatewayRoot();
		const serviceUrl = `${adressenGatewayRoot}${routePrefix}huisnummers/${gemeenteId}/${postcode}/${straatnaam}`;

		return axios.get(serviceUrl, {
			headers: {}
		});
	},
	getCoordinatenForAdres(gemeentenaam, postcode, straatnaam, huisnummer) {
		const adressenGatewayRoot = getAdressenGatewayRoot();
		let route = routePrefix + 'coordinaten/' + gemeentenaam + '/' + postcode + '/' + straatnaam;

		if (huisnummer) {
			route += '/' + huisnummer;
		}

		const serviceUrl = `${adressenGatewayRoot}${route}`;

		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default AdressenGatewayApi;
